import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { SAVE_PROJECT_IDEA } from "./graphql";

const ProjectIdeaForm = ({ originalIdea, onSaved }) => {
  const [content, setContent] = useState(originalIdea?.content || "");
  const [saveProjectIdea, saveProjectIdeaRes] = useMutation(SAVE_PROJECT_IDEA, {
    onCompleted() {
      Alert("success", "Project ideas saved successfully");
      onSaved?.();
    },
    onError() {
      Alert("error", "Failed to save project ideas");
    },
    refetchQueries: ["FETCH_PROJECT_IDEAS"],
    awaitRefetchQueries: true,
  });

  function saveHandler() {
    saveProjectIdea({
      variables: { id: originalIdea?.id, content },
    });
  }

  return (
    <div>
      <Text value={content} onChange={(e) => setContent(e.target.value)} />

      <div className="mt-6">
        <Button
          primary
          onClick={saveHandler}
          loading={saveProjectIdeaRes.loading}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default ProjectIdeaForm;
